import { Component, OnInit, OnDestroy, viewChild, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NavItem, NavItemType } from '../../md/md.module';
import { Location } from '@angular/common';
import { NavbarComponent } from '../../modules/navbar/navbar.component';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

// Constantes a nivel de archivo
const SCROLL_THRESHOLD = 960;

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  public navItems: NavItem[];
  /** Controla la apertura del sidebar como drawer en mobile (<992px). */
  public mobileMenuOpen = false;
  private routerSubscription: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];

  // Migrated to signal-based queries
  readonly sidebar = viewChild('sidebar');
  readonly navbar = viewChild(NavbarComponent);

  constructor(private router: Router, private location: Location) {}

  ngOnInit() {
    this.initializeScrollTracking();
    this.initializeNavItems();
    this.setupPerfectScrollbar();
  }

  ngAfterViewInit() {
    this.runOnRouteChange();
  }

  private initializeScrollTracking(): void {
    this.location.subscribe((ev) => {
      this.lastPoppedUrl = ev.url;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url !== this.lastPoppedUrl) {
          this.yScrollStack.push(window.scrollY);
        }
      } else if (event instanceof NavigationEnd) {
        if (event.url === this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else {
          window.scrollTo(0, 0);
        }
      }
    });

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.resetScrollPositions();
      // Cierra el drawer mobile al navegar a otra sección.
      this.closeMobileMenu();
    });
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  private resetScrollPositions(): void {
    const elemMainPanel = document.querySelector('.main-panel') as HTMLElement;
    const elemSidebar = document.querySelector('.sidebar .sidebar-wrapper') as HTMLElement;

    if (elemMainPanel) {
      elemMainPanel.scrollTop = 0;
    }
    if (elemSidebar) {
      elemSidebar.scrollTop = 0;
    }
  }

  private setupPerfectScrollbar(): void {
    const html = document.documentElement;

    if (window.matchMedia(`(min-width: ${SCROLL_THRESHOLD}px)`).matches && !this.isMac()) {
      const elemMainPanel = document.querySelector('.main-panel') as HTMLElement;
      const elemSidebar = document.querySelector('.sidebar .sidebar-wrapper') as HTMLElement;

      new PerfectScrollbar(elemMainPanel);
      new PerfectScrollbar(elemSidebar);
      html.classList.add('perfect-scrollbar-on');
    } else {
      html.classList.add('perfect-scrollbar-off');
    }
  }

  private initializeNavItems(): void {
    this.navItems = [
      { type: NavItemType.NavbarLeft, title: 'Dashboard', iconClass: 'fa fa-dashboard' },
      {
        type: NavItemType.NavbarRight,
        title: '',
        iconClass: 'fa fa-bell-o',
        numNotifications: 5,
        dropdownItems: [
          { title: 'Notification 1' },
          { title: 'Notification 2' },
          { title: 'Notification 3' },
          { title: 'Notification 4' },
          { title: 'Another Notification' }
        ]
      },
      {
        type: NavItemType.NavbarRight,
        title: '',
        iconClass: 'fa fa-list',
        dropdownItems: [
          { iconClass: 'pe-7s-mail', title: 'Messages' },
          { iconClass: 'pe-7s-help1', title: 'Help Center' },
          { iconClass: 'pe-7s-tools', title: 'Settings' },
          'separator',
          { iconClass: 'pe-7s-lock', title: 'Lock Screen' },
          { iconClass: 'pe-7s-close-circle', title: 'Log Out' }
        ]
      },
      { type: NavItemType.NavbarLeft, title: 'Search', iconClass: 'fa fa-search' },
      { type: NavItemType.NavbarLeft, title: 'Account' },
      {
        type: NavItemType.NavbarLeft,
        title: 'Dropdown',
        dropdownItems: [
          { title: 'Action' },
          { title: 'Another action' },
          { title: 'Something' },
          { title: 'Another action' },
          { title: 'Something' },
          'separator',
          { title: 'Separated link' },
        ]
      },
      { type: NavItemType.NavbarLeft, title: 'Log out' }
    ];
  }

  public isMap(): boolean {
    return this.location.prepareExternalUrl(this.location.path()) === '/maps/fullscreen';
  }

  private runOnRouteChange(): void {
    if (window.matchMedia(`(min-width: ${SCROLL_THRESHOLD}px)`).matches && !this.isMac()) {
      const elemSidebar = document.querySelector('.sidebar .sidebar-wrapper') as HTMLElement;
      const elemMainPanel = document.querySelector('.main-panel') as HTMLElement;

      const ps = new PerfectScrollbar(elemMainPanel);
      ps.update();
    }
  }

  private isMac(): boolean {
    return /MAC|IPAD/.test(navigator.platform.toUpperCase());
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
